import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import "../styles/patientLookup.css";
import SearchByFieldStepController from "./SearchByFieldStepController.jsx";
import PatientSelectStepController from "./PatientSelectStepController.jsx";
import PatientLookupMessageBoxController from "./PatientLookupMessageBoxController.jsx";
import PatientEnterDOBStepController from "./PatientEnterDOBStepController.jsx";
const I18n = require('react-redux-i18n').I18n;

class PatientLookupApp extends Component {
    render () {

        let body;

        if (this.props.step === 1) {
            body = <SearchByFieldStepController />
        } else if (this.props.step === 2) {
            body = <PatientSelectStepController />
        } else if (this.props.step === 3) {
            body = <PatientEnterDOBStepController />
        }

        return  (
            <div className="container">
                <div className="lookup-header">
                    <img src="png/logo.png" className="progeny-logo"/>
                    <div className="questionnaire-name" dangerouslySetInnerHTML={{ __html: this.props.title}}>
                    </div>
                </div>
                <div className="lookup-container">
                    {body}
                    <div className="lookup-footer">
                        Progeny {this.props.progenyVersion}
                    </div>
                </div>
                <PatientLookupMessageBoxController />
            </div>
        );
    }
}

PatientLookupApp.PropTypes = {
    progenyVersion: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
    return {
        progenyVersion: state.progenyInfo.version,
        title: state.questionnaire.title,
        step: state.currentStep.stepNumber
    }
};

const mapDispatchToProps = dispatch => {
    return {
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientLookupApp);